import { observable } from 'mobx';
import RequestModel from '../models/RequestModel';
import RawDataModel from '../models/RawDataModel';
import BaseStore from './BaseStore';

class RequestStore extends BaseStore {
  constructor(transportLayer) {
    super(RequestModel, transportLayer);
  }

  _fetchRawDataByRequestId(id) {
    return this.transportLayer.fetchRawDataByRequestId(id);
  }

  // fetchRawDataByRequestId(requestId) {
    // this.isLoading = true;

    // this
      // ._fetchRawDataByRequestId(requestId)
      // .then(fetchedItems => {
        // fetchedItems.forEach(json => {
          // this.updateRawDataFromServer(json);
          // this.isLoading = false;
        // });
      // })
      // .catch(err => {
        // console.log('err', err);
        // this.isLoading = false;
      // });
  // }

  // updateRawDataFromServer(json) {
    // if (!json.id) { return; }

    // let rawDataItem = this.rawData.find(el => +el.id === +json.id);
    // if (!rawDataItem) {
      // rawDataItem = new RawDataModel(this, json);
      // this.rawData.push(rawDataItem);
    // }
    // // console.log('requestItem.rawDataItems', requestItem.rawDataItems);
    // // if (json.isDeleted) {
      // // this.removeItem(item);
    // // } else {
      // // item.updateFromJson(json);
    // // }
  // }

  // updateItemFromServer(json) {
    // if (!json.id) { return; }
    // let item = this.items.find(el => +el.id === +json.id);
    // if (!item) {
      // item = new this.Model(this, json);
      // this.items.push(item);
    // }
    // if (json.isDeleted) {
      // this.removeItem(item);
    // } else {
      // item.updateFromJson(json);
    // }
  // }
}

export default RequestStore;



// WEBPACK FOOTER //
// ./src/stores/RequestStore.js